import React, {useImperativeHandle} from "react";
import { Avatar, Tag } from "antd";
import AspectCard from "@/component/AspectCard";
import { AudioIcon } from "@/component/ToggleIcon";
import VideoView from "./VideoView";
import { ParticipantType } from "@/types";
import Tool from "@/pages/Meeting/Tool";
import style from "./style.module.scss";
import avatarImage from "../../../../assets/images/avatar-image.png";
import callingImage from "../../../../assets/images/call-calling.svg";

interface PropType {
  participant: ParticipantType;
  active?: boolean;
  showTag?: boolean;
  showTool?: boolean;
  cover?: boolean;
}

const VideoCard = React.forwardRef((props:PropType, ref: any) => {
  const { participant, showTag = true, showTool = true, cover } = props;

  return (
    <AspectCard
      className={style.container}
      active={participant.active}
      cover={cover}
      sos={participant.sosPressed}
    >
      <VideoView
        ref={ref}
        peerId={participant.peerId}
        videoTrack = {participant.videoTrack}
        // video={participant.video}
        // audio={participant.audio}
        // local={participant.local}
        // share={participant.share}
      />

      {!participant.video && (
        <>
        { 
          participant.peerName == "90007070" ? 
          <img src={callingImage} style={{ width: "50px" }} alt="callingImage" />
          :
          <img src={avatarImage} style={{ borderRadius: "50%"}} alt="avatarImage" />
          // {/* {participant.peerName} */}
        }
        </>
      )}

      {showTag && (
        <Tag className={`${style.tag} ${participant.sosPressed ? style.sos : "" }`}>
          {/* <span className={style.host}>主持人</span> */}
          {/* {!participant.audio && <AudioIcon active={false} />} */}
          <span className={style.name}>
            {participant.peerName == "90007070" ? "Операторын хэрэглэгч" : participant.peerName}
            {participant.sosPressed ? " - SOS " : ""}
            {participant.local ? "( Би )" : ""}
          </span>
        </Tag>
      )}

      {showTool && <Tool className={style.tool} participant={participant} />}
    </AspectCard>
  );
});
export default VideoCard;
